import {createGlobalStyle, css} from 'styled-components';
import {
    black,
    bold,
    book,
    darkBlue,
    heavy,
    hover,
    medium,
    regular,
    semibold,
    text,
    title,
    white
} from './globalStyleVars';

function createCSS() {
    let styles = '';

    for (let i = 2; i < 20; i += 1) {
        styles += `
        .anim-active.fade-up:nth-child(${i}) {
          transition-delay: ${i * .12}s;
        }
     `
    }

    for (let a = 2; a < 100; a += 1) {
        styles += `
        .anim-active.fade-right span:nth-child(${a}) {
          transition-delay: ${a * .03}s;
        }
     `
    }

    return css`${styles}`;
}

export default createGlobalStyle`

  ${createCSS()}
  #root {
    min-height: 100vh;
    overflow-x: hidden;
  }

  //@font-face {
  //  font-family: 'Inter';
  //  src: url('/fonts/Inter-Black.woff2') format('woff2'),
  //  url('/fonts/Inter-Black.woff') format('woff');
  //  font-weight: 900;
  //  font-style: normal;
  //  font-display: swap;
  //}
   ::-webkit-scrollbar {
     width: 0.8rem;
   }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${darkBlue};
    border: 5px solid transparent;
    border-radius: 9px;
    background-clip: content-box;

  }


  @font-face {
    font-family: 'Inter Regular';
    src: url('/fonts/Inter-Regular.woff2') format('woff2'),
    url('/fonts/Inter-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter Bold';
    src: url('/fonts/Inter-Bold.woff2') format('woff2'),
    url('/fonts/Inter-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter Medium';
    src: url('/fonts/Inter-Medium.woff2') format('woff2'),
    url('/fonts/Inter-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter SemiBold';
    src: url('/fonts/Inter-SemiBold.woff2') format('woff2'),
    url('/fonts/Inter-SemiBold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  html{
    overflow-y: scroll;
    scrollbar-color: ${black} #F8F8F8;
    scrollbar-width: thin;

    &.modal-open {
      overflow-y: auto;
      // other styles...
    }

  }
  @media (max-width: 767px) {
    html {
      overflow-y: auto; /* Remove the scrollbar on mobile */
    }
  }
  body {
    font-family: 'Inter', Arial, Helvetica, freesans, sans-serif !important;
    font-style: normal;
    margin: 0;
    color: ${black};
    padding: 0;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    background: #F8F8F8;

    //&::-webkit-scrollbar {
    //  display: none;
    //}
    //
    //&::-moz-scrollbar {
    //  display: none;
    //
    //}
  }
  .rc-scrollbars-container{
    position: relative !important;
  }

  .rc-scrollbars-track-v{
    background-color: transparent;
  }
  .rc-scrollbars-thumb-v{
    background-color: ${black} !important;
    max-height: 85px !important;
  }

  a {
    transition: color .3s ease;
    text-decoration: none;

    &:hover {
      color: ${hover} !important;
      text-decoration: none;
      outline: none;
      box-shadow: none;
    }

    &:focus {
      text-decoration: none;
      outline: none;
      box-shadow: none;
      color: ${text};
    }
  }

  ::selection {
    background: ${hover};
    color: #FFF;
  }

  //typography
  h1 {
    font-size: 72px;
    line-height: 80px;
    font-family: ${regular};
  }

  h2 {
    font-size: 60px;
    line-height: 64px;
    font-family: ${bold};
  }

  h3 {
    font-family: ${semibold};
    font-size: 40px;
    line-height: 44px;
  }

  h4 {
    font-family: ${regular};
    font-size: 28px;
    line-height: 32px;
  }

  h5 {
    font-family: ${bold};
    font-size: 24px;
    line-height: 28px;
  }

  h6 {
    font-family: ${medium};
    font-size: 20px;
    line-height: 28px;
  }

  p {
    font-family: ${regular};
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 44px;
      line-height: 52px;
    }

    h2 {
      font-size: 40px;
      line-height: 44px;
    }

    h3 {
      font-size: 36px;
      line-height: 40px;
    }

    h4 {
      font-size: 28px;
      line-height: 36px;
    }

    h5 {
      font-size: 24px;
      line-height: 28px;
    }

    h6 {
      font-size: 20px;
      line-height: 28px;
    }
  }

  p, a, h4, h3, h5, h6 {
    color: ${white};
      // font-family: ${medium};
    margin: 0;
  }

  h1, h2 {
      //font-family: ${title};
    margin: 0;
  }

  ul {
    margin: 0;
    padding: 0
  }

  li {
    list-style: none;
  }

  img {
    max-width: 100%;
    object-fit: contain;
  }


  .btn:focus, button:focus, button:active:focus, .btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
    outline: none;
    box-shadow: none;
  }

  //toastify
  .toastify {
    position: fixed !important;
    z-index: 999999999 !important;
  }

  .toastify {
    z-index: 999999999 !important;
  }

  .Toastify__toast-container {
    z-index: 99999999 !important;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid rgba(0, 0, 0, 0);
    -webkit-text-fill-color: #000;
    -webkit-box-shadow: 0 0 0px 1000px rgba(0, 0, 0, 0) inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  //Custom scrollbar

  

  table {
    width: 100%;
  }

  form div {
    position: relative;
  }

  .form-control {
    box-shadow: none;
    outline: 0;
    border-radius: 0;

    &:focus {
      box-shadow: none;
    }

  }


  .p-0 {
    padding: 0 !important;
  }

  .pl-0 {
    padding-left: 0;
  }

  .pr-0 {
    padding-right: 0;
  }

  .pt-200 {
    padding-top: 200px;
    @media (max-width: 767px) {
      padding-top: 120px;
    }
  }

  .pb-200 {
    padding-bottom: 200px;
    @media (max-width: 767px) {
      padding-bottom: 120px;
    }
  }

  .pt-160 {
    padding-top: 160px;
    @media (max-width: 767px) {
      padding-top: 150px;
    }
  }


  .pt-120 {
    padding-top: 120px;
    @media (max-width: 767px) {
      padding-top: 60px;
    }
  }

  .pb-160 {
    padding-bottom: 160px;
    @media (max-width: 767px) {
      padding-bottom: 150px;
    }
  }

  .pb-130 {
    padding-bottom: 130px;
    @media (max-width: 767px) {
      padding-bottom: 100px;
    }
  }

  .pb-120 {
    padding-bottom: 120px;
    @media (max-width: 767px) {
      padding-bottom: 60px;
    }
  }

  .pt-100 {
    padding-top: 100px;
    @media (max-width: 767px) {
      padding-top: 60px;
    }
  }

  .pb-100 {
    padding-bottom: 100px;
    @media (max-width: 767px) {
      padding-bottom: 60px;
    }
  }

  .pt-80 {
    padding-top: 80px;
    @media (max-width: 767px) {
      padding-top: 40px;
    }
  }

  .pb-80 {
    padding-bottom: 80px;
    @media (max-width: 767px) {
      padding-bottom: 40px;
    }
  }


  .MuiDrawer-paper {
    width: 500px !important;
    padding: 20px;
    @media (max-width: 767px) {
      width: 100% !important;
    }
  }

  .swiper-button-disabled {
    opacity: 0 !important;
  }

  @media (min-width: 1500px) {
    .container {
      //min-width: 1366px;
      min-width: 85%;
      margin: auto;
    }
  }

  @media (max-width: 1199px) and (min-width: 768px) {
    .container, .container-lg, .container-md, .container-sm {
      max-width: 90%;
      margin: auto;
    }
  }


  @media (max-width: 767px) {
    .container, .container-sm {
      max-width: 100%;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }


  //react select
  .css-yk16xz-control, .css-1pahdxg-control {
    height: 50px;
    border-radius: 0 !important;
    padding-left: 5px;
    font-size: 16px;
    outline: none !important;
    border-color: #D9D9D9 !important;
    box-shadow: none !important;

    .css-1wa3eu0-placeholder {
      font-weight: 300;
      line-height: 21px;
      color: rgba(0, 0, 0, 0.5);
      outline: none;
    }

    .css-1okebmr-indicatorSeparator {
      display: none;
    }

    .css-tlfecz-indicatorContainer, .css-1gtu0rj-indicatorContainer {
      margin-right: 10px;
    }
  }

  .css-2613qy-menu {
    border-radius: 0 !important;
    margin-top: 0 !important;
  }

  //animation class


  .info-window {
    max-width: 200px;
  }

  .gm-style-iw {
    border-radius: 0 !important;
  }

  .swiper-pagination-bullet {
    outline: none;
  }

  .css-nmuc1a-menu {
    z-index: 5 !important;
  }


  .map-info__img {
    img {
      height: 100px;
      margin-bottom: 12px;
      object-fit: cover;
    }
  }

  .map-info__content {
    h4 {
      font-size: 20px;
    }

    p {
      margin-bottom: 5px;
    }
  }

  .overlay {
    position: fixed;
    height: 100vh;
    width: 100%;
    //background-color: rgba(0,0,0,0.5);
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    display: none;

    &.show {
      display: block;
    }
  }

  .form-control.has-error {
    border-color: #dc004e !important;
  }

  .has-error .find-retainer-filter__control {
    border-color: #dc004e !important;
  }

  //preloader
  .content-loader {
    position: absolute;
    height: 70%;
    width: 70%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .loading-before-submit {
    position: fixed;
    height: 100vh;
    width: 100%;
    bottom: 0;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.65);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 40px;
    }
  }


  .swiper-slide {
    height: auto;
  }

  .slick-slide {
    div {
      outline: none !important
    }
  }

  button, button:active, button:focus, button:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }


  .hover {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      z-index: 2;
    }

    svg {
      position: relative;
      z-index: 2;
    }

    &:after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      right: 0;
      top: 100%;
      margin: auto;
      background-color: ${hover};
      transition: all .5s ease;
      border-radius: 50%;
    }

    &:hover {
      &:after {
        top: 0;
      }
    }
  }

  .modal-backdrop {
    background-color: rgb(34 31 31 / 90%);
    min-width: 100%;
    z-index: 9999;

    &.show {
      opacity: 1;
    }
  }


  .valid {
    color: ${hover};
    position: absolute;
    font-size: 12px;
    top: 44px;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }


  //menu fixed
  .scroll-down .menu-desktop {
    transform: translate3d(0, -100%, 0);
  }

  .scroll-up .menu-desktop {
    background-color: #fff;

    .menu-desktop__hamburger__lines {
      &__inner .line {
        background-color: #191818;
      }

      p {
        color: #191818;
      }
    }

    .menu-desktop__hamburger .controller svg {
      path {
        fill: #191818;
      }

      line {
        stroke: #191818;
      }
    }

    .dc-btn a {
      color: #191818;

      &:hover {
        color: #191818 !important;
      }

      &:after, &:before {
        box-shadow: 0 0 0 1px #191818;
      }
    }
  }

  .form-control:disabled {
    background-color: transparent;
  }

  @media (max-width: 600px) {
    .prevent-overflow {
      overflow: hidden;
      height: 100vh;
    }
  }

  .Toastify__toast-container {
    z-index: 99999999;
  }

  .mobile-menu {
    #fb-root, .fb_reset {
      display: none !important;
      opacity: 0 !important;
      visibility: hidden !important;
    }
  }

  .slick-slide {
    -webkit-transform: translate3d(0, 0, 0);
  }

  .reveal, .revealFast {
    overflow: hidden;
    height: 100%;
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;

    img {
      transform-origin: left;
    }

    .global-image {
      background: transparent;
    }
  }

  //calender
  ._3efP_GeH5kyBAzqnLzL._kN_bCa3VNYpqFLH311L {
    border-radius: 0 !important;
  }

  //video modal 
  .modal-video-close-btn:before, .modal-video-close-btn:after {
    background-color: ${hover};
  }

  //page loader
  .page-loader {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgb(6, 21, 36);
    z-index: 999999999;
    display: none;
    opacity: 0;
    //display: flex;
    align-items: center;
    justify-content: center;

    img{
      width: 96px;
      height: 45px;
    }

    svg {
      height: 80px;
      opacity: 0;
      @media (max-width: 767px) {
        margin-left: 5%;
      }
    }
  }

  //------------------------animation
  .split-parent {
    overflow: hidden;
  }

  .split-child {
    overflow: hidden;
  }

  .reveal {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    img {
      transform-origin: left;
    }

    .global-image {
      background: transparent;
    }
  }


  //page transition
  .page-transition {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: ${darkBlue};
    z-index: 999999999;
    display: none;
    opacity: 0;
    //display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      height: 80px;
      opacity: 0;
    }
  }

  //founder popup
  .founder-modal {
    background-color: ${darkBlue};
    height: 100vh;
    z-index: 99999;

    overflow: hidden !important;


    .modal-dialog {
      height: 100vh;
      background-color: transparent;
      min-width: 100%;
      margin: 0;
    }

    .modal-body {
      height: 100vh;
    }

    .modal-content {
      background-color: transparent;
      padding: 100px 0;

      h3 {
        font-size: 36px;
        line-height: 44px;
        margin-bottom: 30px;
        color: #F5F5F5;
      }

      h4 {
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 30px;
        color: #F5F5F5;

        span {
          display: block;
        }
      }

      .images {
        position: relative;

        &__big {
          position: relative;
          padding-top: calc(400 / 670 * 100%);
        }

        &__small {
          margin-top: 30px;
          margin-bottom: 100px;

          img {
            width: 100%;
          }
        }

      }

      p {
        color: ${white};

        &:not(:nth-last-child(1)) {
          margin-bottom: 20px;
        }
      }

      .image-gallery-slider {
        position: relative;
        //margin-bottom: 150px;

        .navigation {
          position: absolute;
          bottom: 30px;
          right: 0;
        }

        .swiper-slide-active {
          p {
            transition-delay: 0.7s;
            opacity: 1;
          }
        }

        p {
          opacity: 0;
          transition: 0.7s all ease;
          max-width: 70%;
          margin-top: 50px;
        }
      }

      .img-group-caption {
        margin-bottom: 40px;

        .img-wrapper-big {
          position: relative;
          padding-top: calc(520 / 870 * 100%);
        }

        p {
          margin-top: 20px;
        }
      }

      //navigation
      .navigation {
        position: absolute;
        right: ${props => props.offset ? props.offset : '0'}px;
        //top: calc(50% - 10vh);
        //transform: translateY(-100%);
        display: inline-block;
        z-index: 1;

        ul {
          display: flex;
          flex-direction: row-reverse;

          li {
            cursor: pointer;

            &:first-child {
              margin-bottom: 20px;
              margin-right: 0;
              margin-left: 30px;
            }

            &:last-child {
              margin-left: 30px !important;
            }

            svg {
              path, #Rectangle_5661 {
                //transition: strokeDasharray 0.3s ease-in-out;
                transition: all 1s cubic-bezier(.25, .74, .22, .99);
              }
            }


            &:hover {
              svg {
                #Rectangle_5661 {
                  opacity: 1;

                  stroke-dasharray: 140px;
                }

                path {
                  stroke: ${hover};
                }
              }
            }
          }
        }
      }
    }

    @media (max-width: 767px) {
      .modal-content {
        padding-top: 80px;

        .container {
          height: calc(100vh - 100px);
          overflow: scroll;

          h3 {
            margin-top: 30px;
            font-size: 28px;
            line-height: 35px;
          }
        }

        .images {
          &__small {
            margin-top: 30px;
            margin-bottom: 70px;

            img {
              margin-bottom: 30px;
            }
          }

        }

      }

      .founder-modal__img {
        height: 50vh;
      }

    }
  }


  //associalte modal 
  .associate-modal {
    .founder-modal__img {
      padding-top: calc(280 / 370 * 100%);
      //background-color: #fff;
      position: relative;

      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
        //margin: auto;
      }
    }

    .founder-modal__add {
      margin-top: 20px;

      p {
        color: ${white};
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 0px !important;
      }

      h6 {
        font-family: ${bold};
      }
    }

    table{
      margin-top: 20px;
      margin-bottom: 40px;
      tbody{
        border-top: 2px solid transparent !important;
      }
      th{
        border-top: none;
        text-align: start;
        padding: 0;
      }
      tr{
        &:last-child{
          td{
            border-bottom: 1px solid transparent;
          }
        }
        th{
          color: ${white};
          padding-bottom: 20px;
          // border-bottom: 1px solid ${white};
        }
        td{
          color: ${text};
          padding-bottom: 20px;
          padding-top: 20px;
          border-bottom: 1px solid ${text};
          padding-left: 0px !important;
        }

      }
    }
  }


  //team popup
  .team-modal {
    background-color: ${darkBlue};
    height: 100vh;
    z-index: 99999;
    overflow: hidden !important;
    width: 668px;
    right: 0;
    left: auto;
    padding: 0px 70px 30px 70px !important;

    .close-button {
      right: 70px;
      position: fixed;
      opacity: 0;
      transition-delay: .6s;
    }

    .modal-dialog {
      height: 100vh;
      background-color: transparent;
      min-width: 100%;
      margin: 0;
    }

    .modal-body {
      height: 100vh;
    }

    .modal-content {
      background-color: transparent;
      margin: 100px 0;
      //overflow: scroll;
      //height: calc(100vh - 120px);

      .team-modal__content {
        &__header {
          margin-top: 20px;
          margin-bottom: 40px;

          p {
            &:first-child {
              font-family: ${bold};
              color: ${white};
            }

            &:last-child {
              color: ${text};
            }
          }
        }

        &__body {
          p {
            margin-bottom: 24px;

            &:last-child {
              margin-bottom: 0px;
            }
          }
        }

      }
    }

    @media (max-width: 767px) {
      width: 100%;
      padding: 0 20px 10px 20px !important;
      .close-button {
        right: 20px;
        position: fixed;
      }

      .modal-content {
        //padding-top: 80px;

        .container {
          //height: calc(100vh - 100px);
          //overflow: scroll;

          h3 {
            margin-top: 30px;
            font-size: 28px;
            line-height: 35px;
          }
        }
      }

      //overflow: scroll !important;

    }
  }

  .modal-open {
    .close-button {
      opacity: 1;
      //transition-delay: .6s;
    }
  }

  //get in touch modal 
  .modal.get-touched {
    z-index: 999999;
    height: 100vh;
    right: 0;
    left: auto;
    width: 668px;
    opacity: 1 !important;
    //background-color: #F6F6F6;

    .modal-dialog {
      min-width: 100%;
      margin: 0;
      transform: translateX(100%);

      .modal-content {
        height: 100vh;
        width: 100%;
        right: 0;
        background-color: ${darkBlue};
        padding: 80px 100px 40px 40px;
      }
    }

    &.show {
      .modal-dialog {
        transform: none;
      }
    }


    .slide-form {


      h4 {
        font-size: 28px;
        line-height: 36px;
        color: ${white};
        margin-bottom: 60px;
        font-weight: 600;
      }

      .form-control {
        margin-bottom: 40px;
        border: 0;
        border-bottom: 1px solid ${text};
        border-radius: 0;
        padding-left: 0;
        font-size: 16px;
        line-height: 24px;
        background-color: transparent;
        color:${white};


        ::placeholder {
          color: ${text};
        }
      }

      textarea {
        max-height: 80px;
      }

      .close-btn {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 20px;
        right: 20px;
        position: absolute;
        background-color: transparent;
        border: 1px solid ${white};
        cursor: pointer;

        svg {
          line {
            stroke: #FFF
          }
        }

        line {
          transition: .3s ease;
        }

        &:hover {
          svg {
            line {
              stroke: #FFF
            }
          }
        }
      }

    }

    @media (max-width: 767px) {
      width: 100%;
      .modal-dialog .modal-content {
        padding: 80px 20px 40px 20px;
      }
    }
  }

  //menu fixed
  .scroll-down {
    .main-menu-mobile__bar, .main-menu {
      transform: translate3d(0, -100%, 0);
    }
  }


  .scroll-up, .menu-v2 {
    .main-menu {
      backdrop-filter: blur(5px);
      background-color: rgba(20, 38, 55, 0.4);

    }

    .main-menu-mobile__bar {
      background-color: #3C3C3B;
    }
  }

  //video modal
  .modal-video {
    background-color: transparent;
    height: 100vh;
    z-index: 99999;

    .modal-dialog {
      height: 100vh;
      background-color: transparent;
      min-width: 100%;
      margin: 0;
    }

    .modal-body {
      height: 100vh;
    }

    .modal-content {
      background-color: transparent;

    }

    iframe {
      height: 60vh;
      width: 60vw;
      margin: auto;
      position: absolute;
      inset: 0;
    }

    .close-modal {
      position: absolute;
      top: 40px;
      right: 30px;
      height: 30px;
      cursor: pointer;
      z-index: 1000;
    }

    @media (max-width: 768px) {
      .modal-content {
        //padding: 0 20px;

        iframe {
          width: 90vw;
          height: 60vh;
        }

        .close-modal {
          top: 80px;
          right: 20px;
        }
      }
    }
    @media (max-width: 550px) {
      .modal-content iframe {
        width: 90vw;
        height: 40vh;
      }
    }
  }
`;



